import { render, staticRenderFns } from "./AliPlayer.vue?vue&type=template&id=64f8e520&scoped=true&"
import script from "./AliPlayer.vue?vue&type=script&lang=js&"
export * from "./AliPlayer.vue?vue&type=script&lang=js&"
import style0 from "./AliPlayer.vue?vue&type=style&index=0&id=64f8e520&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f8e520",
  null
  
)

export default component.exports